/**
 * Centralized z-index constants for the forced top-layer mode.
 *
 * When forceTopLayer is active the widget must sit above any host-page
 * element (e.g. sticky headers with z-index: 9999).  The base value is
 * close to the signed 32-bit integer ceiling so virtually nothing can
 * overlap the widget.
 *
 * Layers are ordered bottom → top:
 *   WIDGET_OVERLAY  < WIDGET_FRAME  < PDF_OVERLAY  < PDF_FRAME
 */

const TOP_LAYER_BASE = 2147483000;

export const TOP_LAYER_Z = {
  WIDGET_OVERLAY: TOP_LAYER_BASE + 1,
  WIDGET_FRAME: TOP_LAYER_BASE + 2,
  PDF_OVERLAY: TOP_LAYER_BASE + 3,
  PDF_FRAME: TOP_LAYER_BASE + 4,
} as const;
